module.exports = __webpack_public_path__ + "img/weihu.915f0c83.png";